// extracted by mini-css-extract-plugin
module.exports = {"marketName":"MarketName_marketName__1WmJZ"};